export enum CheckPoint {
  Conversation = "conversation",
  Default = "default",
}
